import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconArrowEnter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.87891 6.39844H0.199219V1.01953H1.40625V5.17969H6.87891V3.10547L9.59766 5.78906L6.87891 8.48438V6.39844Z",
		fill: "#475569"
	})
});
export default SvgIconArrowEnter;
